export default __webpack_public_path__ + "static/media/GSRR_18.17c0b773.svg";